import React from 'react';
import classNames from 'classnames';

import Card from './Card/Card';

import css from './TwoColumnSection.module.scss';

const TwoColumnSection = ({
	heading,
	data,
	images,
	hideMobile,
	btnText,
	customClass,
}) => {
	return (
		<section className={classNames(css.twoColumnSection, css[customClass])}>
			{!hideMobile && heading && <h2>{heading}</h2>}
			{data.map(props => {
				return (
					<Card
						key={props.id}
						images={images}
						btnText={btnText}
						hideMobile={hideMobile}
						{...props}
					/>
				);
			})}
		</section>
	);
};

export default TwoColumnSection;
